export const cards = [
  {
    titulo: 'SHEDULE2_0.CARDS.PASO1.TITULO',
    completo: false
  },
  // {
  //   titulo: 'SHEDULE2_0.CARDS.PASO7.TITULO',
  //   logoEmpresa: false,
  //   visibleEmpresa: true,
  //   logoCertificado: true,
  //   visibleCertificado: true,
  //   completo: true
  // },
];

export const secciones = [
  {
    id: 'encuesta',
    titulo: 'SHEDULE2_0.SECCIONES.ENCUESTA.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ENCUESTA.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ENCUESTA.ERROR',
    icono: 'insert_drive_file',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'usuarios',
    titulo: 'SHEDULE2_0.SECCIONES.USUARIOS.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.USUARIOS.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.USUARIOS.ERROR',
    icono: 'people',
    visible: true,
    completo: false,
    fallo: false
  },
  {
    id: 'encuesta-50',
    titulo: 'Encuesta menos de 50',
    // titulo: 'SHEDULE2_0.SECCIONES.ENCUESTA.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ENCUESTA.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ENCUESTA.ERROR',
    icono: 'insert_drive_file',
    visible: false,
    completo: false,
    fallo: false
  },
  {
    id: 'encuesta+50',
      titulo: 'Encuesta mas de 50',
    // titulo: 'SHEDULE2_0.SECCIONES.ENCUESTA.TITULO',
    proceso: 'SHEDULE2_0.SECCIONES.ENCUESTA.PROCESO',
    error: 'SHEDULE2_0.SECCIONES.ENCUESTA.ERROR',
    icono: 'insert_drive_file',
    visible: false,
    completo: false,
    fallo: false
  },

];

export const tipoCorreos = [
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO1.TITULO'
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO2.TITULO'
  },
  {
    titulo: 'SHEDULE2_0.CORREOS.TIPO3.TITULO'
  },
];
